import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyData = lazyWithRetry(() => import("./Data"));

const Data = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyData {...props} />;

export default Data;
